import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons'
import { TimelineBtn } from '../../components/common/TimelineBtn'
import { ThemeHeading } from '../../components/common/ThemeHeading'

export default function TimeLine() {
    return (
        <section className="resume-wrapper site-margin" id="resumes">
            <div className="container">
               <ThemeHeading heading="Career Background" />
               <div className="resume-outer-box">
                  <div className="resume-main-icon">
                     <span>
                        <FontAwesomeIcon icon={faGraduationCap} />
                     </span>
                  </div>
                  <div className="resume-main-content">
                     <div className="resume-timeline-item mb-4 resumes-box-1 wow rotateInDownRight" data-wow-duration="2s"
                        data-wow-delay="0.11s">
                        <div className="row">
                           <TimelineBtn BtnClass="timeline-btn-left resume-timeline-btn" BtnName="2015-2016" />
                           <div className="col-sm-6">
                              <div className="timeline-content-right border timeline-dec">
                                 <h4>UX Designer</h4>
                                 <span>Vivo - Senior Designer</span>
                                 <p>The generated injected humour, or non-characteristic words etc. Cum sociis natoque
                                    penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="resume-timeline-item mb-4 resumes-box-2 wow rotateInDownLeft" data-wow-duration="2s"
                        data-wow-delay="0.13s">
                        <div className="row">
                           <div className="col-sm-6">
                              <div className="timeline-content-left border timeline-dec">
                                 <h4>Web Developer</h4>
                                 <span>Oppo - HR Manager</span>
                                 <p>The generated injected humour, or non-characteristic words etc. Cum sociis natoque
                                    penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis
                                 </p>
                              </div>
                           </div>
                           <TimelineBtn BtnClass="timeline-btn-right resume-timeline-btn" BtnName="2016-2017" />
                        </div>
                     </div>
                     <div className="resume-timeline-item mb-4 resumes-box-3 wow rotateInDownRight" data-wow-duration="2s"
                        data-wow-delay="0.15s">
                        <div className="row">
                        <TimelineBtn BtnClass="timeline-btn-left resume-timeline-btn" BtnName="2017-2018" />
                           <div className="col-sm-6">
                              <div className="timeline-content-right border timeline-dec">
                                 <h4>Graphic Designer</h4>
                                 <span>Apple - Testor</span>
                                 <p>The generated injected humour, or non-characteristic words etc. Cum sociis natoque
                                    penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="resume-timeline-item mb-4 resumes-box-4 wow rotateInDownLeft" data-wow-duration="2s"
                        data-wow-delay="0.17s">
                        <div className="row">
                           <div className="col-sm-6">
                              <div className="timeline-content-left border timeline-dec">
                                 <h4>React js</h4>
                                 <span>Iphone - Developing</span>
                                 <p>The generated injected humour, or non-characteristic words etc. Cum sociis natoque
                                    penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis
                                 </p>
                              </div>
                           </div>
                           <TimelineBtn BtnClass="timeline-btn-right resume-timeline-btn" BtnName="2018-2019" />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
    )
}